import { render, staticRenderFns } from "./UkrTreasuresPayPalButtonsCreateSection.vue?vue&type=template&id=212321f8"
import script from "./UkrTreasuresPayPalButtonsCreateSection.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresPayPalButtonsCreateSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports